import React from "react";
import Navbar from "./Components/Navbar/Navbar"; 
import FooterSection from "./Components/Footer/Footer"; 
import MainSection from "./Components/MainSection/MainSection"; 

const LendingPartners_v2 = () => {
  return (
    // iOS FIX: Changed min-h-screen to min-h-[100dvh]
    <div className="flex relative flex-col bg-[#FBF8F3] z-0 min-h-[100dvh]">
      
      {/* iOS FIX: Changed h-screen to h-[100dvh] so the background doesn't jump on scroll */}
      <img 
        src="/assets/img/bgGrid.png" 
        alt="Grid Background"
        className="fixed top-0 left-0 w-full h-[100dvh] object-cover -z-10"
      />
      
      <Navbar />

      <main className="flex-grow w-full max-w-7xl mx-auto z-10 relative">
        <MainSection />
      </main>

      <FooterSection />
    </div>
  );
};

export default LendingPartners_v2;